import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { PromotionLeaderboardComponent } from './promotion-leaderboard.component';
import { PromotionLeaderboardGroupComponent } from './group/promotion-leaderboard-group.component';

const routes: Routes = [
    {
        path: '',
        component: PromotionLeaderboardComponent
    },
    {
        path: 'group',
        component: PromotionLeaderboardGroupComponent
    },
    {
        path: 'pm-leaderboard',
        component: PromotionLeaderboardComponent
    },
    {
        path: 'pm-leaderboard/group',
        component: PromotionLeaderboardGroupComponent
    }
];

@NgModule({
    imports: [
        RouterModule.forChild(routes)
    ],
    exports: [
        RouterModule
    ],
    providers: []
})
export class PromotionLeaderboardRoutingModule {
}
